import React, { FC } from 'react';
import {
    SkeletonBlock,
    SkeletonFooterBar,
    SkeletonPageHeader,
    SkeletonPageShell,
    SkeletonResponsiveGrid,
    SkeletonRow,
    SkeletonStack,
    SkeletonSurface
} from 'src/components/widgets/skeleton';

const ToolToggleSkeleton: FC = () => (
    <SkeletonSurface $padding='24px'>
        <SkeletonStack $gap='22px'>
            <SkeletonRow $gap='12px'>
                <SkeletonBlock $width='42px' $height='22px' $radius='999px' />
                <SkeletonBlock $width='min(300px, 70%)' $height='16px' />
            </SkeletonRow>
            <SkeletonResponsiveGrid $columns='repeat(2, minmax(0, 1fr))' $gap='24px'>
                {Array.from({ length: 2 }).map((_, index) => (
                    <SkeletonSurface key={index} $padding='20px'>
                        <SkeletonStack $gap='16px'>
                            <SkeletonBlock $width='120px' $height='18px' />
                            <SkeletonRow $gap='12px'>
                                <SkeletonBlock $width='18px' $height='18px' $radius='4px' />
                                <SkeletonBlock $width='220px' $height='14px' />
                            </SkeletonRow>
                            <SkeletonBlock $width='170px' $height='12px' />
                            <SkeletonBlock $width='120px' $height='36px' $radius='6px' />
                            <SkeletonStack $gap='10px'>
                                {Array.from({ length: index === 0 ? 4 : 2 }).map((_, optionIndex) => (
                                    <SkeletonRow key={optionIndex} $gap='10px'>
                                        <SkeletonBlock $width='16px' $height='16px' $radius='4px' />
                                        <SkeletonBlock $width={optionIndex % 2 === 0 ? '180px' : '140px'} $height='13px' />
                                    </SkeletonRow>
                                ))}
                            </SkeletonStack>
                        </SkeletonStack>
                    </SkeletonSurface>
                ))}
            </SkeletonResponsiveGrid>
        </SkeletonStack>
    </SkeletonSurface>
);

export const AIImageGenerationPageSkeleton: FC = () => (
    <SkeletonPageShell aria-hidden='true' $padding='20px 0 92px'>
        <SkeletonPageHeader>
            <SkeletonStack $gap='8px' $flex='1'>
                <SkeletonRow $gap='10px'>
                    <SkeletonBlock $width='300px' $height='28px' />
                    <SkeletonBlock $width='82px' $height='22px' $radius='999px' />
                    <SkeletonBlock $width='64px' $height='22px' $radius='999px' />
                </SkeletonRow>
                <SkeletonBlock $width='min(680px, 100%)' $height='13px' />
                <SkeletonBlock $width='90px' $height='13px' />
            </SkeletonStack>
        </SkeletonPageHeader>
        <SkeletonStack $gap='20px'>
            <ToolToggleSkeleton />
            <SkeletonSurface $padding='22px'>
                <SkeletonStack $gap='16px'>
                    <SkeletonBlock $width='180px' $height='20px' />
                    <SkeletonRow $gap='14px'>
                        <SkeletonBlock $width='18px' $height='18px' $radius='4px' />
                        <SkeletonBlock $width='260px' $height='14px' />
                    </SkeletonRow>
                    <SkeletonRow $gap='14px'>
                        <SkeletonBlock $width='18px' $height='18px' $radius='4px' />
                        <SkeletonBlock $width='220px' $height='14px' />
                    </SkeletonRow>
                </SkeletonStack>
            </SkeletonSurface>
            <SkeletonBlock $height='58px' $radius='6px' />
            <SkeletonBlock $height='58px' $radius='6px' />
        </SkeletonStack>
        <SkeletonFooterBar>
            <SkeletonBlock $width='88px' $height='36px' $radius='6px' />
        </SkeletonFooterBar>
    </SkeletonPageShell>
);
